/* eslint-disable indent */
import Header from './Sections/Header/Header';
import { useInView } from 'react-intersection-observer';
import SectionReorderModal from 'components/SectionReorderModal';

import TrialingInformation from './Sections/TrialingInformation';
import SeedDensityAdvice from 'pages/RecommendationV2/Sections/SeedDensityAdvice';
import VaLowerBanner from './Sections/VaBanner/VaLowerBanner';
import { VaLowerBannerMobile } from './Sections/VaBanner/VaLowerBannerMobile';
import OSREditBanner from 'components/OSREditBanner';
import IconUpArrow from 'components/Icons/IconUpArrow';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppState } from 'context/AppState';
import { useFlowActions } from 'context/actions/flowActions';
import { ActionTypes, useApiDataActions } from 'context/actions/ApiDataActions';
import {
  Field,
  OsrSummaryResponse,
  RecommendationCropwiseResponse,
  Tpr,
} from 'base/types/RecommendationCropwise';
import { PreBookSeedsPayload } from 'base/types/PreBookSeeds';
import * as turf from '@turf/turf';
import { getBagsCount } from 'utils/getBagsCount';
import {
  BackToTopBtn,
  FeedbackBtn,
  FeedbackImg,
  LandscapeWarningMessageContainer,
  Root,
  ContentContainer,
  DiagnosticTab,
  RecommendationTab,
  PrimaryContainer,
  SecondaryContainer,
} from './RecommendationV2.styles';
import 'c3/c3.css';
import routes from 'base/constants/routes';
import lookup from 'country-code-lookup';
import ProxyLayer, { VaReportPayload } from 'base/api/ProxyLayer';
import { useBreakpoint } from 'hooks';
import {
  ERecommendationSections,
  InputAndDiagnosticsTabName,
  RecommendationTabName,
} from 'utils/constants/RecommendationSections';
import SectionTabs, { SectionTab } from './Sections/SectionTabs/SectionTabs';
import RecommendationInfo from './Sections/RecommendationInfo/RecommendationInfo';
import HeroBanner0a from './Sections/HeroBanner0a/HeroBanner0a';
import HeroBanner0b from './Sections/HeroBanner0b/HeroBanner0b';
import ReportOverview from './Sections/ReportOverview/ReportOverview';
import { useTranslation } from 'react-i18next';
import feedbackIcon from '../../assets/images/feedback.png';
import track from 'utils/amplitudeWrapper';
import { UsageGroups } from 'utils/constants/UsageGroups';
import axios from 'axios';
import { UserLocation } from 'base/types/UserLocation';
import { useRecaptchaEnterpriseVerification } from 'hooks/useRecaptchaEnterpriseVerification';
import { showCookiebotIcon } from 'utils/helpers/cookiebot';
import { findRegionalLocation } from 'base/services/location';
import VoucherExplanation from './Sections/VoucherExplanation';
import { setUserId } from '@amplitude/analytics-browser';
import { isEmail } from 'utils/validator';
import {
  trackGrowerOpenedRecommendation,
  trackGrowerOpenedRecommendationDirect,
  trackGrowerOpenedRecommendationDDG,
  trackVAReportAccessed,
} from 'utils/helpers/amplitude';

export type PinInfoType = {
  longitude: number;
  latitude: number;
  location: string;
};
import ProductAdvice from './ProductAdvice';
import AgronomicPreferences from 'pages/RecommendationV2/Sections/AgronomicPreferences/AgronomicPreferences';
import { isBase64 } from 'utils/helpers/converter';
import EnvironmentalStress from 'pages/RecommendationV2/Sections/EnvironmentalStress';
import { Footer } from './Sections/Footer';
import { ESectionByDevice, useSectionByDevice } from './hooks/useSectionByDevice';
import SoilCharacteristics from './Sections/SoilCharacteristics';
import { ConfirmationModal } from 'components/ConfirmationModal';
import ShareRecommendationModal from '../../components/ShareRecommendationModal/ShareRecommendationModal';
import { ErrorsTypeMap } from 'utils/constants/ErrorsType';
import { CropConstants, growthStageCrops, isDssatSupported } from 'utils/constants/Crop';
import {
  isGermany,
  isUkraine,
  isUK,
  isPoland,
  isFrance,
  isRussia,
  isSerbia,
  isBelgium,
  isKazakhstan,
  isBelarus,
  isBrazil,
} from 'utils/countryCode';
import GrowthStages from './Sections/GrowthStages/GrowthStages';
import ProductPerformance from './Sections/ProductPerformance/ProductPerformance';
import { StressType } from 'context/store/flowReducer';
import { trackGTMEvent } from 'utils/createGTMEvent';
import { createGrowthStageReqData } from 'utils/growthStage';
import { UserCategories } from 'base/types/AmplitudeClassifiers';
import { createAbioticStageReqData, endDateForGrowthStage, getStartDate } from 'utils/abioticStage';
import ExpertSeedAdvice from './Sections/ExpertSeedAdvice';
import ProductComparison from './Sections/ProductComparison';
import HerbicideTechnology from './Sections/HerbicideTechnology';
import { Divider } from 'syngenta-digital-cropwise-react-ui-kit';
import { trackSource } from '../../utils/trackSource';
import { loadLayoutForUser } from './utils/loadLayoutForUser';
import { isScriptGenerated } from 'utils/isScriptGenerated';
import { getRankingCrop } from 'utils/getRankingCrop';
import { OsrSummary } from 'utils/osrSummary';
import { pollUntilResponse } from 'utils/polling';
import HorizontalTabss, { HorizontalTabs } from './Sections/HorizontalTabs/HorizontalTabs';
import { isOsrSummarySupportedCrop } from './utils/isOsrSummarySupportedCrop';
import { useCookieConsent } from 'hooks/useCookieConsent';

declare global {
  interface Window {
    pendo: any;
    pendoscript: any;
  }
}

export function getQueryParam(url: any, key: any) {
  const query = url.split('?')[1];
  if (!query) {
    return null;
  }

  const pairs = query.split('&');
  for (const pair of pairs) {
    const index = pair.indexOf('=');
    if (index === -1) {
      continue;
    }

    const k = decodeURIComponent(pair.slice(0, index));
    const v = decodeURIComponent(pair.slice(index + 1));
    if (k === key) {
      return v;
    }
  }
  return null;
}

export default function RecommendationV2() {
  const {
    flow: {
      appLanguage,
      abioticStageStressType,
      selectedAbioticFrequencyValue,
      selectedAbioticIntensityValue,
      localCountry,
    },
  } = useAppState();
  const IS_GROWTH_STAGE_ENABLED = ['local', 'dev', 'qa', 'uat', 'prod'].includes(
    process.env.REACT_APP_ENV as string
  );
  const rootRef = useRef<any>();
  const feedbackBtnRef = useRef<any>();
  const isPageScrolled = useRef<boolean>(false);
  const [showBackToTopBtn, setShowBackToTopBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isPendoGuideActive, setIsPendoGuideActive] = useState(false);
  const pageLoadStartTimeRef = useRef(Date.now());
  const marketingEmailSentRef = useRef(false);
  const [isLoadingBreakoutsAPI, setIsLoadingBreakoutsAPI] = useState(true);
  const [isLoadingBreakoutsProductSummaryAPI, setIsLoadingBreakoutsProductSummaryAPI] =
    useState(true);
  const [isLoadingAttributesAPI, setIsLoadingAttributesAPI] = useState(true);
  const [environmentalStressChartInfo, setEnvironmentalStressChartInfo] = useState<Tpr>({} as Tpr);
  const [propertiesFieldsInfo, setPropertiesFieldsInfo] = useState<Field[] | null>(null);
  const [pendoManualOpen, setPendoManualOpen] = useState(false);
  const [userSpentTwoMin, setUserSpentTwoMin] = useState(false);
  const [userSpentThirtySec, setUserSpentThirtySec] = useState(false);
  const [isPendoClosed, setIsPendoClosed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [growthStagePlantingDate, setGrowthStagePlantingDate] = useState<string>('');
  const [vaReportState, setVaReportState] = useState({
    error: false,
    reportSubmited: false,
  });
  const [showSectionReorderModal, setShowSectionReorderModal] = useState(false);
  const [soilCharacteristicsPosition, setSoilCharacteristicsPosition] = useState<number>(3); // 3 = after recommendation-info
  const [sectionOrder, setSectionOrder] = useState<string[]>([
    'hero-banner-0a',
    'hero-banner-0b',
    'report-overview',
    'expert-seed-advice',
    'product-comparison',
    'product-performance',
    'agronomic-preferences',
    'environmental-stress',
    'herbicide-technology',
    'trial-information',
    'growth-stages',
    'seed-density',
  ]);
  const [isVariantD, setIsVariantD] = useState(false);
  const { setEnvironmentalStressTableChartProps, setLocalCountry } = useFlowActions();
  const { isMobile, landscape } = useBreakpoint();
  const { isHumanUser, verifyRecaptcha } = useRecaptchaEnterpriseVerification();
  const isAnyAPILoading =
    isLoading ||
    isLoadingBreakoutsAPI ||
    isLoadingAttributesAPI ||
    isLoadingBreakoutsProductSummaryAPI;
  const option = { threshold: 0.2 };
  const { ref: TrialInformationRef, inView: TrialInformationSectionVisible } = useInView(option);
  const { ref: soilCharRef, inView: soilCharSectionVisible } = useInView(option);

  const { ref: FooterRef, inView: FooterSectionVisible } = useInView(option);
  const { ref: SeedDensityRef, inView: SeedDensitySectionVisible } = useInView(option);
  const { ref: ProductPerformRef, inView: ProductPerformSectionVisible } = useInView(option);
  const { ref: ProductComparisonRef, inView: ProductComparisonSectionVisible } = useInView(option);
  const { ref: ExpertSeedRef, inView: ExpertSeedSectionVisible } = useInView(option);
  const { ref: EnvStressRef, inView: EnvStressSectionVisible } = useInView(option);
  const { ref: agPreferencesRef, inView: agPreferencesSectionVisible } = useInView(option);
  const { ref: herbicideTechRef, inView: herbicideTechSectionVisible } = useInView(option);
  const vaEmailInputRef = useRef<any>(null);
  const diagnosticsSectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const growthStageRef = useRef<HTMLDivElement>(null);
  const paramsd = useParams();
  const params: any = window.location.href.includes('recommendation')
    ? paramsd
    : { recommendation_data: getQueryParam(window.location.href, 'sol_id') };

  let recId = '';
  let decodedRecParamString = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { recommendation_data = '' } = params;
  if (isBase64(recommendation_data)) {
    decodedRecParamString = atob(recommendation_data);
  } else {
    recId = recommendation_data;
  }
  const ApiDataActions = useApiDataActions();
  const appDispatcher = useAppDispatch();

  const [calendarOpenState, setCalendarOpenState] = useState(false); //handle scroll when calendar opens
  const [selectedTab, setSelectedTab] = useState<SectionTab>(RecommendationTabName);
  const [selectedHorizontalTab, setSelectedHorizontalTab] =
    useState<HorizontalTabs>('RecommendedProducts');
  const [isRecommendationAPILoading, setIsRecommendationAPILoading] = useState(true);
  const [currentSection, setCurrentSection] = useState(ERecommendationSections.SECTION_HERO_BANNER);
  const { currentSectionByDevice } = useSectionByDevice({ isMobile, landscape, currentSection });
  const sectionLandscapeAllowed = currentSectionByDevice === ESectionByDevice.landscapeAllowed;
  const [t] = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<string>('');
  const [VaBannerEmail, setVaBannerEmail] = useState('');
  const [isSpecialUser, setIsSpecialUser] = useState(false);
  const [isLayoutLoaded, setIsLayoutLoaded] = useState(false);
  const [showFieldVariability, setShowFieldVariability] = useState(false);
  const [isPreBookButtonVisible, setIsPreBookButtonVisible] = useState(true);
  const { statistics, method } = useCookieConsent();

  const mapCharRef = useRef<HTMLDivElement>(null);
  const handleTabClick = (tab: SectionTab) => {
    setSelectedTab(tab);
    if (tab === InputAndDiagnosticsTabName) {
      track('diagnostics tab', { 'diagnostics tab clicked': true });
    } else if (tab === RecommendationTabName && showGrowthStage()) {
      fetchGSDataForPlantingDate(getStartDate(recommendationCropwise, countryCode ?? '', cropName));
      setGrowthStagePlantingDate(
        recommendationCropwise?.recommendations[0]?.multi_field?.config?.agronomicInputs
          ?.plantingDate ?? `${new Date().getFullYear()}-04-01`
      );
    }
    document
      .getElementById('recommendationProductsCard')
      ?.scrollIntoView({ behavior: 'auto', block: 'start' });
  };

  const handleHorizontalTabClick = (tab: HorizontalTabs) => {
    setSelectedHorizontalTab(tab);
    if (tab === 'RecommendedProducts') {
      track('Recommended Products section', { 'Recommended Products section clicked': true });
    } else if (tab === 'ManagementAndPlantingAdvice' && showGrowthStage()) {
      fetchGSDataForPlantingDate(getStartDate(recommendationCropwise, countryCode ?? '', cropName));
      setGrowthStagePlantingDate(
        recommendationCropwise?.recommendations[0]?.multi_field?.config?.agronomicInputs
          ?.plantingDate ?? `${new Date().getFullYear()}-04-01`
      );
    }
    document
      .getElementById('recommendationProductsCard')
      ?.scrollIntoView({ behavior: 'auto', block: 'start' });
  };

  const handleProductSelection = (productName: string) => {
    setSelectedProduct(productName);
    mapCharRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const { i18n } = useTranslation();
  const {
    apiData: {
      recommendation,
      recommendationCropwise,
      productCatalog,
      nonDDGUserDetails,
      recommendationCropwiseError,
      breakoutsGlobalError,
      breakoutsProductsSummaryError,
      growthStage,
      abioticStage,
      countryList,
    },
  } = useAppState();
  const countryName = recommendationCropwise?.country ?? '';
  const isBrazilCountry = countryName.toLowerCase() === CropConstants.Brazil.toLowerCase();
  const isSouthAfrica = countryName === CropConstants.SOUTH_AFRICA;

  // Get country code with fallback for Russia
  let countryCode = '';
  if (countryName) {
    const lookupResult = lookup.byCountry(countryName?.trim());
    countryCode = lookupResult?.iso2 || '';

    // Fallback for Russia if lookup fails
    if (!countryCode && isRussia(countryName)) {
      countryCode = 'RU';
    }
  }
  const cropName = recommendationCropwise?.recommendations?.[0]?.crop_name ?? '';
  const isDDG = recommendationCropwise?.source === 'DDG';
  const scriptGenerated = isScriptGenerated(recommendationCropwise);
  const shouldUseScriptEndpoint =
    decodedRecParamString && scriptGenerated && isGermany(countryCode);
  const pushRec = recommendation?.PushRec;
  const isSpecialEmail = isSpecialUser;
  const isShared =
    recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
      ?.extended_attributes?.isshared;
  const growerEmail =
    recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
      ?.extended_attributes?.grower_email;
  const solutionId = recommendationCropwise?.id;
  const recomm = recommendationCropwise;
  const timer =
    recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
      ?.extended_attributes?.timer;

  const growerName = recommendationCropwise?.organization_name;
  const cropId = recommendationCropwise?.recommendations[0]?.crop_id || '';

  const tsr_name =
    recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
      ?.extended_attributes?.tsr_name ||
    (recommendationCropwise?.email_id ? recommendationCropwise.email_id.split('@')[0] : '');

  const isEverythingLoaded = !(
    isLoading ||
    isLoadingBreakoutsAPI ||
    isLoadingBreakoutsProductSummaryAPI ||
    isLoadingAttributesAPI ||
    isRecommendationAPILoading
  );

  useEffect(() => {
    const NotEligibleCountries = [
      isUK(countryCode),
      isFrance(countryCode),
      isBelgium(countryCode),
      isGermany(countryCode) && cropId === CropConstants.BARLEY_CROP_ID,
      isBrazil(countryCode),
    ];
    const isEligibleCountry = NotEligibleCountries.some(Boolean);
    setIsPreBookButtonVisible(isDDG && !isEligibleCountry);
  }, [countryCode, cropId, isDDG]);

  // Show ShareRecommendationModal immediately when recommendationCropwise API responds
  useEffect(() => {
    if (recommendationCropwise && !isDDG) {
      // Check if URL contains share=true parameter
      const urlParams = new URLSearchParams(window.location.search);
      const isSharedFromUrl = urlParams.get('share') === 'true';

      if (isSharedFromUrl) {
        setShowPopup(false);
        return;
      }

      // Check timestamp parameter from URL
      const timestampParam = urlParams.get('time');
      if (timestampParam) {
        const urlTimestamp = parseInt(timestampParam, 10);
        const currentTimestamp = Date.now();
        const thirtySecondsMs = 30 * 1000;

        // If more than 30 seconds have passed since the timestamp, don't show popup
        if (currentTimestamp - urlTimestamp > thirtySecondsMs) {
          setShowPopup(false);
          return;
        }
      }

      if (timer) {
        const now = Date.now();
        const threeDaysMs = 3 * 24 * 60 * 60 * 1000;
        if (now - timer >= threeDaysMs) {
          // Timer expired: show popup regardless of isShared
          setShowPopup(true);
        } else {
          // Timer not expired: block popup if isShared is true
          setShowPopup(!isShared ? true : false);
        }
      } else {
        // No timer: block popup if isShared is true
        setShowPopup(!isShared ? true : false);
      }
    }
  }, [recommendationCropwise, timer, isDDG, isShared]);

  // Track when grower opens recommendation from TSR, directly (non-DDG), or DDG
  useEffect(() => {
    if (recommendationCropwise) {
      const fetchVADataStatus = async () => {
        const vaReportId = recommendationCropwise.vareportid;
        if (!vaReportId) {
          setShowFieldVariability(false);
          return;
        }

        try {
          const cancelToken = ProxyLayer.cancelToken();
          const vaStatusResponse = await ProxyLayer.getVaReportStatus(
            vaReportId,
            cancelToken.token
          );

          const { vi_success_fields, az_success_fields } = vaStatusResponse ?? {};

          if (vi_success_fields > 0 && az_success_fields > 0) {
            setShowFieldVariability(true);
          }
        } catch (error) {
          console.error('Error fetching VA report status:', error);
          setShowFieldVariability(false);
        }
      };
      trackSource(recommendationCropwise);
      fetchVADataStatus();
    }
  }, [recommendationCropwise]);
  const showPreBookSeedsBtn = () => {
    return isDDG && !scriptGenerated;
  };

  const location = useLocation();

  // Helper function to call SIP integration API for Serbia users
  const callSIPIntegration = async (): Promise<number | null> => {
    const currentCountry = recommendationCropwise?.country || '';

    if (!recommendationCropwise || !isSerbia(currentCountry)) {
      return null;
    }

    try {
      console.log('Starting SIP integration for marketing email:', {
        country: currentCountry,
        recommendationId: recommendationCropwise?.id,
      });

      // Extract data for the payload
      const { recommendations } = recommendationCropwise;
      const {
        multi_field: {
          config: {
            recommendation: recommendationResults,
            agronomicInputs: recommendationAgronomicInputs,
          },
          geometry,
        },
      } = recommendations[0];

      const { id: recommendationID } = recommendationCropwise;
      const [properties] = geometry.properties || [];

      // Get first and last name from recommendation
      const firstName = recommendation?.userContactFromAudit?.firstName || '';
      const lastName = recommendation?.userContactFromAudit?.lastName || '';

      // Get phone number
      const phoneNumberBasedOnCountry = recommendation?.userContact?.phoneNumber || '';

      // Create plots array
      const plots =
        properties?.fields.map((field) => {
          const [longitude, latitude] = turf.centroid(field.geometry).geometry.coordinates;
          return {
            name: field.name,
            latitude,
            longitude,
            acreage: Number(field.declared_area.toFixed(2)),
            acreageUnitOfMeasure: 'ha',
          };
        }) || [];

      // Create recommended hybrids array
      const recommendedHybrids: { name: string; quantity: number }[] = recommendationResults
        .map((item) => {
          const field = properties?.fields.find((fieldItem) => fieldItem.id === item.FieldId);
          if (item?.SeedRankings?.length) {
            const seedName = item.SeedRankings[0].Seed?.SeedName || 'Unknown';
            const countryCodeValue = lookup.byCountry(recommendationCropwise.country)?.iso3;
            const product = productCatalog.find((p) => p.productName === seedName);
            const defaultSeedingRate = Number(product?.defaultSeedingRate) || 0;
            const hectares = field?.declared_area || 0;
            const spatialClass = recommendationAgronomicInputs?.spatialClass ?? '';
            const bags = getBagsCount({
              product,
              hectares,
              defaultSeedingRate,
              countryList,
              countryCode: countryCodeValue,
              cropId,
              spatialClass,
            });

            return {
              name: seedName,
              quantity: bags,
            };
          } else {
            return {
              name: 'N/A',
              quantity: 0,
            };
          }
        })
        .reduce((acc: { name: string; quantity: number }[], current) => {
          // Sum same products/seeds
          const index = acc.findIndex((i) => i.name === current.name);
          if (index < 0) {
            acc.push(current);
          } else {
            acc[index].quantity += current.quantity;
          }
          return acc;
        }, []);

      const recoHybridsNames = recommendedHybrids.map((item) => item.name);

      const getSeedName = (rs: any) => {
        if (rs.SeedName) {
          return rs.SeedName;
        }
        return rs.Seed ? rs.Seed.SeedName : '';
      };

      let nextBestHybrids = recommendationResults
        .map((item) => item.SeedRankings.map((rs, index) => index < 6 && (getSeedName(rs) || '')))
        .flat()
        .filter((seed) => seed && !recoHybridsNames.includes(seed));

      // Remove duplicates
      nextBestHybrids = Array.from(new Set(nextBestHybrids));

      const payload: PreBookSeedsPayload = {
        recommendationID,
        Country: countryCode || 'RS',
        cropName:
          recommendationCropwise.recommendations[0].crop_name === CropConstants.CORN_SMALLCASE
            ? CropConstants.GRAIN_CORN
            : recommendationCropwise.recommendations[0].crop_name,
        User: {
          Email: recommendation?.email || '',
          FirstName: firstName,
          LastName: lastName,
          phone: phoneNumberBasedOnCountry || '',
        },
        plots,
        recommendedHybrids,
        nextBestHybrids,
      };

      // Make the API call to SIP via proxy service
      const response = await ProxyLayer.preBookSeeds(payload);

      console.log('SIP integration response for marketing email:', response);

      if (response && response.id) {
        console.log('SIP integration completed successfully, ID:', response.id);
        return response.id;
      } else {
        console.error('SIP integration failed - Invalid response structure:', response);
        return null;
      }
    } catch (error) {
      console.error('Error during SIP integration for marketing email:', error);
      return null;
    }
  };

  useLayoutEffect(() => {
    showCookiebotIcon();
  }, []);
  useEffect(() => {
    if (isHumanUser !== undefined) {
      return;
    }
    verifyRecaptcha();
  }, [isHumanUser, verifyRecaptcha]);

  useEffect(() => {
    if (!isMobile || currentSectionByDevice !== ESectionByDevice.desktopOrMobile) {
      // Not update the current visible section on landscape
      return;
    }

    const pageSections = {
      [ERecommendationSections.SECTION_TRIALING_INFORMATION]: TrialInformationSectionVisible,
      [ERecommendationSections.SECTION_SOILS_CHARACTERISTICS]: soilCharSectionVisible,
      [ERecommendationSections.SECTION_SEED_DENSITY_ADVICE]: SeedDensitySectionVisible,
      [ERecommendationSections.SECTION_PRODUCT_PERFORMANCE]: ProductPerformSectionVisible,
      [ERecommendationSections.SECTION_AG_PREFERENCES]: agPreferencesSectionVisible,
      [ERecommendationSections.SECTION_PRODUCT_COMPARISON]: ProductComparisonSectionVisible,
      [ERecommendationSections.SECTION_EXPERT_SEED_ADVICE]: ExpertSeedSectionVisible,
      [ERecommendationSections.SECTION_ENV_STRESS]: EnvStressSectionVisible,
      [ERecommendationSections.SECTION_HERBICIDE_TECHNOLOGY]: herbicideTechSectionVisible,
    };

    const currentSectionAllowed = Object.keys(pageSections).find((key) => pageSections[key]);
    setCurrentSection(currentSectionAllowed || '');
  }, [
    TrialInformationSectionVisible,
    ProductPerformSectionVisible,
    currentSectionByDevice,
    SeedDensitySectionVisible,
    agPreferencesSectionVisible,
    ProductComparisonSectionVisible,
    ExpertSeedSectionVisible,
    isMobile,
    EnvStressSectionVisible,
    soilCharSectionVisible,
    herbicideTechSectionVisible,
  ]);

  useEffect(() => {
    const dateAndTime = new Date().toUTCString();
    let sectionName = '';

    switch (true) {
      case TrialInformationSectionVisible:
        sectionName = 'trial information section';
        break;
      case SeedDensitySectionVisible:
        sectionName = 'seed density advices section';
        break;
      case ProductPerformSectionVisible:
        sectionName = 'product performance by stress level section';
        break;
      case agPreferencesSectionVisible:
        sectionName = 'agronomic preference section';
        break;
      case EnvStressSectionVisible:
        sectionName = 'environmental stress section';
        break;
      case ExpertSeedSectionVisible:
        sectionName = 'expert seed advice section';
        break;
      case ProductComparisonSectionVisible:
        sectionName = 'product comparison section';
        break;
      case herbicideTechSectionVisible:
        sectionName = 'herbicide technology and weed control section';
        break;
      default:
        break;
    }

    if (sectionName) {
      track('recommendation scroll level', {
        [sectionName]: dateAndTime,
        'recommendation ID': recId,
      });
    }
  }, [
    TrialInformationSectionVisible,
    SeedDensitySectionVisible,
    ProductPerformSectionVisible,
    EnvStressSectionVisible,
    agPreferencesSectionVisible,
    ExpertSeedSectionVisible,
    ProductComparisonSectionVisible,
    herbicideTechSectionVisible,
  ]);

  useEffect(() => {
    const cancelToken = ProxyLayer.cancelToken();
    (async () => {
      const checkApiResponse = () => {
        if ((window as any).apiResponse) {
          const endTime = new Date().getTime();
          const loadTime = endTime - (window as any).startTime;
          console.log(
            'in react ActionTypes took time ==> ',
            loadTime / 1000,
            ' seconds',
            new Date()
          );
          appDispatcher({
            type: ActionTypes.setRecommendationCropwise,
            payload: { data: (window as any).apiResponse },
          });
          setIsRecommendationAPILoading(false);
          return true;
        }
      };
      try {
        if (decodedRecParamString) {
          const input = {
            decodedRecParamString: decodedRecParamString,
            source: 'NonDDG',
          };
          for (let i = 0; i < 36; i++) {
            console.log('attempt non-ddg ->', new Date());
            if (i === 35) {
              window.location.reload();
              return;
            }
            const success = checkApiResponse();
            if (success) {
              // Call getLayouts API after recommendation data is loaded
              const apiResponse = (window as any).apiResponse;
              if (!isScriptGenerated(apiResponse)) {
                await loadLayoutForUser(setIsSpecialUser, setSectionOrder, setIsVariantD, 'NonDDG');
              }
              setIsLayoutLoaded(true);
              return;
            }
            await new Promise((res) => setTimeout(res, 500));
          }
        } else {
          const input = {
            solutionId: recId,
            source: 'DDG',
          };
          for (let i = 0; i < 36; i++) {
            console.log('attempt ddg ->', new Date());

            if (i === 35) {
              window.location.reload();
              return;
            }
            const success = checkApiResponse();
            if (success) {
              // For DDG users, call getRecommendationInput directly after apiResponse is loaded
              try {
                await ApiDataActions.getRecommendationInput(recId, {
                  cancelToken: cancelToken.token,
                });
                console.log('Successfully loaded recommendation input data for DDG user');
              } catch (error) {
                console.error('Error loading recommendation input data:', error);
              }
              // Call getLayouts API after recommendation data is loaded
              // await loadLayoutForUser(setIsSpecialUser, setSectionOrder, 'DDG');
              // setIsLayoutLoaded(true);
              return;
            }
            await new Promise((res) => setTimeout(res, 500));
          }
          // This is a fallback if the apiResponse check didn't succeed
          try {
            await ApiDataActions.getRecommendationInput(recId, { cancelToken: cancelToken.token });
          } catch (error) {
            console.error('Error in fallback recommendation input load:', error);
          }
        }
        setIsRecommendationAPILoading(false);
      } catch (e) {
        // TODO: catch the error and display UI for the error
        console.error('Error!!', e);
      }
    })();

    return () => {
      cancelToken?.cancel();
    };
  }, [ApiDataActions, recId]);

  useEffect(() => {
    window.sessionStorage.setItem('langFromRecommendationPage', i18n.language);
  }, [i18n.language]);

  const trackRecOpening = (source: string) => {
    track('DDG rec opens', {
      'opened through': source,
      recId: recId,
      'flagged as created by devs': recommendation?.PushRec,
    });
  };

  const trackPageOpen = () => {
    if (isDDG) {
      if (location?.search?.includes('dest=SMS')) {
        trackRecOpening('SMS');
      } else {
        trackRecOpening('E-mail');
      }
    } else {
      if (recommendationCropwise?.email_id) {
        trackUserCategory(recommendationCropwise.email_id);
      }
    }
  };

  const trackUserCategory = (email: string): void => {
    if (isEmail(email)) {
      ProxyLayer.isSyngentaUser(email)
        .then((result) => {
          track('SSS seed rec opens', {
            'Opened by':
              result.status || email.includes('@syngenta.co')
                ? UserCategories.SYNGENTA_USER
                : UserCategories.NON_SYNGENTA_USER,
            recId: decodedRecParamString,
          });
        })
        .catch(() => {
          console.error('isSyngentaUser error');
          track('SSS seed rec opens', {
            'Opened by': email.includes('@syngenta.co')
              ? UserCategories.SYNGENTA_USER
              : UserCategories.NON_SYNGENTA_USER,
            recId: decodedRecParamString,
          });
        });
    }
  };

  const fetchGSDataForPlantingDate = useCallback(
    (newDate: Date | string) => {
      if (IS_GROWTH_STAGE_ENABLED && recommendationCropwise) {
        const date = typeof newDate === 'object' ? newDate.toISOString().split('T')[0] : newDate;
        const growthStageReqData = createGrowthStageReqData(
          recommendationCropwise,
          date,
          productCatalog
        );
        const cancelToken = ProxyLayer.cancelToken();
        if (growthStageReqData) {
          ApiDataActions.getGrowthStageDetails(growthStageReqData, cancelToken.token);
        }
      }
    },
    [recommendationCropwise, IS_GROWTH_STAGE_ENABLED, ApiDataActions, productCatalog]
  );

  const handlePlantingDateOnGrowthGraph = useCallback(
    (newDate: Date) => {
      setGrowthStagePlantingDate(newDate.toISOString().split('T')[0]);
      fetchGSDataForPlantingDate(newDate);
    },
    [recommendationCropwise, IS_GROWTH_STAGE_ENABLED, ApiDataActions, productCatalog]
  );
  useEffect(() => {
    if (growthStageRef.current) {
      const hash = window.location.hash.substring(1);

      if (hash === 'phenological-growth-stages') {
        setTimeout(() => {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  growthStageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                  observer.disconnect();
                }
              });
            },
            { threshold: 1.0 }
          );

          if (growthStageRef.current) {
            observer.observe(growthStageRef.current);
          }
          growthStageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 5000);
      }
    }
  }, [growthStage, growthStageRef.current]);

  const growthStageStyle = {
    scrollMarginTop: isMobile ? '175px' : '160px', // Adjust the value as needed
  };

  useEffect(() => {
    if (recommendationCropwise && growthStagePlantingDate && showGrowthStage()) {
      getDataForAbioticStress(recommendationCropwise, growthStagePlantingDate);
    }
  }, [
    abioticStageStressType,
    selectedAbioticFrequencyValue,
    selectedAbioticIntensityValue,
    growthStagePlantingDate,
    growthStage,
  ]);

  const getDataForAbioticStress = (
    recommendationCropwise: RecommendationCropwiseResponse,
    plantingDate: string
  ) => {
    const abioticStageReqData = createAbioticStageReqData(
      recommendationCropwise,
      plantingDate,
      countryCode ?? '',
      abioticStageStressType ?? StressType.Frequency,
      selectedAbioticIntensityValue ?? '',
      selectedAbioticFrequencyValue ?? ''
    );
    const cancelToken = ProxyLayer.cancelToken();
    ApiDataActions.getAbioticStageDetails(abioticStageReqData, cancelToken.token);
  };

  const osrSummaryPayload = OsrSummary();

  const showVaBanner = () => {
    // Only show VA banner in production environment
    if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'prod') {
      if (
        recommendationCropwise?.solution_type?.toLowerCase()?.trim().includes('spot_check') ||
        recommendationCropwise?.solution_type?.toLowerCase()?.trim() === 'spot check' ||
        recommendationCropwise?.country?.toLowerCase()?.trim() === 'ukraine' ||
        recommendationCropwise?.country?.toLowerCase()?.trim() === 'russia' ||
        recommendationCropwise?.country?.toLowerCase()?.trim() === 'russian federation'
      ) {
        return false;
      }

      // If source is not DDG (non-DDG users)
      if (!isDDG) {
        // Hide banner if country is Ukraine, Russia, Kazakhstan or Belarus
        if (
          isUkraine(countryCode) ||
          isRussia(countryCode) ||
          isBelarus(countryCode) ||
          isKazakhstan(countryCode)
        ) {
          return false;
        }
        // Show banner for all other non-DDG users (seller versions)
        return true;
      }

      // For DDG users, show VA Banner in production for all DDG recommendations
      return true;
    }
    // Hide VA banner for all non-production environments
    return false;
  };

  const showGrowthStage = () => {
    const isSupported = isDssatSupported(cropName, countryCode ?? '');
    if (!isSupported) {
      return false;
    }
    if (recommendationCropwise) {
      const countryCode = recommendationCropwise?.country
        ? lookup.byCountry(recommendationCropwise?.country)?.iso3
        : '';
      const IS_GERMANY = isGermany(countryCode);
      // do not display growth stage for Germany & Brazil on prod
      if (
        process.env.REACT_APP_ENV &&
        process.env.REACT_APP_ENV === 'prod' &&
        (IS_GERMANY || isBrazilCountry)
      ) {
        return false;
      }

      const maxOldRecommendationDateAllowed = new Date();
      maxOldRecommendationDateAllowed.setDate(maxOldRecommendationDateAllowed.getDate() - 305);
      return (
        IS_GROWTH_STAGE_ENABLED &&
        !moment(
          recommendationCropwise?.recommendations[0].multi_field.config?.agronomicInputs
            ?.plantingDate
        ).isBefore(maxOldRecommendationDateAllowed) &&
        growthStageCrops?.includes(cropName.toLowerCase())
      );
    }
    return false;
  };

  // Only show herbicide-technology section if crop is sunflower and country is BG, HU, RO, UA
  const cropNameValue = recommendationCropwise?.recommendations?.[0]?.crop_name?.toLowerCase();
  const countryLookup = recommendationCropwise?.country
    ? lookup.byCountry(recommendationCropwise?.country?.trim())
    : undefined;
  const countryIso2 = countryLookup?.iso2 ? countryLookup.iso2.toUpperCase() : '';
  const showHerbicideTechnologySection =
    cropNameValue === (CropConstants?.SUNFLOWER_SMALLCASE || 'sunflower') &&
    ['BG', 'HU', 'RO', 'UA'].includes(countryIso2);

  useEffect(() => {
    const getPinDataForEnvironmentalStressTable = () => {
      if (
        recommendationCropwise?.solution_type &&
        recommendationCropwise?.solution_type === 'spot_check'
      ) {
        const pinCoordinates =
          recommendationCropwise?.recommendations[0]?.multi_field?.geometry?.properties[0]
            ?.reference_point?.coordinates;
        const pinData: PinInfoType = {
          longitude: Number(pinCoordinates[0].toFixed(3)),
          latitude: Number(pinCoordinates[1].toFixed(3)),
          location: recommendationCropwise?.country.trim(),
        };
        return {
          pinInfo: pinData,
          isDropAPin: true,
        };
      }
      return {
        pinInfo: null,
        isDropAPin: false,
      };
    };

    (async () => {
      try {
        if (recommendationCropwise) {
          if (recommendationCropwise.email_id) {
            const timeToGetRecommendation = moment
              .duration(moment.utc().diff(moment(recommendationCropwise.updated_on).utc()))
              .asMinutes();
            track('clicks on get recommendation', {
              'user clicks on get recommendation': timeToGetRecommendation,
            });
          }
          trackPageOpen();
          // Data for Pin
          const pinDataEnvironmentTable = getPinDataForEnvironmentalStressTable();

          // Data for Environmental Stress
          const { recommendations } = recommendationCropwise;
          const {
            crop_type: cropType,
            crop_name: cropName,
            multi_field: {
              assignments,
              config: { recommendation: recommendationInfo },
              geometry: { properties },
            },
            crop_id: cropId,
          } = recommendations[0];
          const propertiesFieldInfo = properties.map((item) => item.fields).flat();
          let propertiesAndBoundaries;
          if (propertiesFieldInfo.length) {
            propertiesAndBoundaries = propertiesFieldInfo.map((propertyField: Field) => {
              return {
                ...propertyField,
                estimatedSize: propertyField.declared_area || 0, // Get the hectares from the propertyField
              };
            });
            setPropertiesFieldsInfo(propertiesAndBoundaries);
          }
          if (recommendationInfo.length) {
            const biggestField = assignments.reduce(
              (prevValue, currentAssignment) => {
                const size =
                  currentAssignment?.products?.length > 0
                    ? currentAssignment.products[0].applied_area
                    : 0;
                if (size > prevValue.size) {
                  prevValue = {
                    id: currentAssignment.field_id,
                    size: size,
                  };
                }
                return prevValue;
              },
              { id: '', size: 0 }
            );
            const biggestRecommendationInfo =
              recommendationInfo.find((recomm) => recomm.FieldId === biggestField.id) ||
              recommendationInfo[0];

            const info =
              biggestRecommendationInfo?.AdditionalData?.YieldRankEurope?.tpr ??
              biggestRecommendationInfo?.AdditionalData?.YieldRankEurope?.trp;

            setEnvironmentalStressChartInfo(info);
          }

          setEnvironmentalStressTableChartProps({
            props: {
              ...pinDataEnvironmentTable,
              propertiesFieldsInfo: propertiesAndBoundaries ?? null,
              tabInfo: recommendationInfo.length ? recommendationInfo : null,
            },
          });

          const countryName = recommendationCropwise?.country || '';
          let countryIsoCode = '';
          const countryCode = recommendationCropwise?.country
            ? lookup.byCountry(recommendationCropwise?.country)?.iso3
            : '';
          if (decodedRecParamString) {
            //call userdetails api and bind the data as required
            const urlParams = new URLSearchParams(decodedRecParamString);
            const email = urlParams.get('email') ?? '';
            const cancelToken = ProxyLayer.cancelToken();
            Promise.all([ApiDataActions.getUserDetails(email, cancelToken.token)]);
          }
          countryIsoCode = lookup.byCountry(countryName)?.iso2 ?? '';
          let cropTypeForProduct = cropType;
          if (isBrazilCountry) {
            cropTypeForProduct = cropName;
          }
          Promise.all([
            ApiDataActions.getProductCatalog(cropTypeForProduct, countryName),
            ApiDataActions.getCountries(false, countryIsoCode),
          ]).then(() => setIsLoading(false));

          const getCropName = () => {
            if (isBrazilCountry) {
              if (
                recommendationCropwise?.recommendations?.[0]?.crop_name.toLowerCase() === 'soybeans'
              ) {
                return 'SOY';
              } else {
                return recommendationCropwise?.recommendations?.[0]?.crop_name;
              }
            }
            return recommendationCropwise?.recommendations?.[0]?.crop_name;
          };

          const commonParams = {
            solutionId: recommendationCropwise?.id,
            ...(decodedRecParamString && { decodedRecParamString: decodedRecParamString }),
            source: decodedRecParamString ? 'NonDDG' : 'DDG',
            solutionType: recommendationCropwise?.solution_type,
            rankingCrop:
              recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
                .cropRanking ||
              recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
                ?.extraInfo?.cropRegion,
            soilTexture:
              recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.recommendation?.[0]
                ?.AdditionalData?.YieldRankEurope?.texture,
            crop_name: getCropName(),
            country: recommendationCropwise?.country,
            countryRegion:
              recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
                ?.extraInfo?.countryRegion,
            yieldRange: recommendationCropwise?.encryptedYieldRange || '',
            rankings: recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.rankings,
            yieldRangeUnit:
              recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
                ?.extraInfo?.yieldRangeUnit,
            yieldRank:
              recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.recommendation?.[0]
                ?.AdditionalData?.YieldRankEurope,
            SelectedSeeds: recommendationCropwise?.encryptedSelectedSeeds || '',
          };

          Promise.all([
            ApiDataActions.getBreakoutsGlobalRecommendationId({
              ...commonParams,
              // solutionId: recommendationCropwise.id,
              // ...(decodedRecParamString && { decodedRecParamString: decodedRecParamString }),
              // source: decodedRecParamString ? 'NonDDG' : 'DDG',
              withFilters: false,
            }),
            ApiDataActions.getBreakoutsGlobalRecommendationId({
              ...commonParams,
              // solutionId: recommendationCropwise.id,
              // source: decodedRecParamString ? 'NonDDG' : 'DDG',
              // ...(decodedRecParamString && { decodedRecParamString: decodedRecParamString }),
              withFilters: true,
            }),
          ]).then(() => setIsLoadingBreakoutsAPI(false));

          Promise.all([
            ApiDataActions.getBreakoutsProductsSummaryRecommendationId({
              ...commonParams,
              withFilters: false,
            }),
            ApiDataActions.getBreakoutsProductsSummaryRecommendationId({
              ...commonParams,
              withFilters: true,
            }),
          ])
            .then(() => setIsLoadingBreakoutsProductSummaryAPI(false))
            .catch(() => setIsLoadingBreakoutsProductSummaryAPI(false));
          ApiDataActions.getAttributes(undefined, countryCode, cropId, [
            UsageGroups.WEIGHTING,
            UsageGroups.PDF,
          ]).then(() => setIsLoadingAttributesAPI(false));
        }
      } catch (error) {
        // TODO: catch the error and display UI for the error
        console.error('Error!!', error);
      }
    })();
  }, [recommendationCropwise]);

  useEffect(() => {
    try {
      if (recommendationCropwise && growthStage.length === 0 && productCatalog.length > 0) {
        const { recommendations } = recommendationCropwise;
        const {
          multi_field: {
            config: { agronomicInputs },
          },
        } = recommendations[0];
        if (showGrowthStage()) {
          setGrowthStagePlantingDate(
            agronomicInputs.plantingDate ?? `${new Date().getFullYear()}-04-01`
          );
          fetchGSDataForPlantingDate(
            agronomicInputs.plantingDate ?? `${new Date().getFullYear()}-04-01`
          );
        }
      }
    } catch (error) {
      console.error('Error fetching growth stage data:', error);
    }
  }, [productCatalog]);

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();
    const fetchRegionalData = async () => {
      try {
        const data: UserLocation = await findRegionalLocation({ cancelToken: cancelToken?.token });
        const { country = 'de' } = data || {};
        setLocalCountry({ country: String(country).toLocaleLowerCase() });
      } catch (e) {
        console.error('error', e);
      }
    };
    fetchRegionalData();
    return () => {
      cancelToken?.cancel();
    };
  }, []);

  const trackPageLoadCompletionTime = () => {
    const pageLoadStartTime = pageLoadStartTimeRef.current;
    const pageLoadEndTime = Date.now();
    const pageLoadTime = (pageLoadEndTime - pageLoadStartTime) / 1000;
    track('recommendation loading stats', {
      'load start time': new Date(pageLoadStartTime).toLocaleTimeString(),
      'load end time': new Date(pageLoadEndTime).toLocaleTimeString(),
      'load duration': pageLoadTime,
    });
  };

  const extractUtmParameters = (urlParams: URLSearchParams): Record<string, string> => {
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const extractedParams: Record<string, string> = {};

    utmParams.forEach((param) => {
      const value = urlParams.get(param);
      if (value) {
        extractedParams[param] = value;
      }
    });

    return extractedParams;
  };

  const buildEmailPayload = (
    recId: string,
    sipIntegrationId: number | undefined,
    utmParams: Record<string, string>,
    endpoint?: 'marketing-email-scripts',
    recommendationCropwiseData?: any,
    productCatalogData?: any
  ) => {
    // For marketing-email-scripts endpoint, send the full recommendationCropwise object
    if (endpoint === 'marketing-email-scripts' && recommendationCropwiseData) {
      return {
        recommendationCropwise: recommendationCropwiseData,
        productCatalog: productCatalogData,
      };
    }

    // For regular marketing email endpoint, send minimal payload
    const emailPayload: any = { recommendationSolutionId: recId };

    if (sipIntegrationId) {
      emailPayload.sipIntegrationId = sipIntegrationId;
    }

    Object.assign(emailPayload, utmParams);

    return emailPayload;
  };

  const sendMarketingEmail = async (
    recId: string,
    sipIntegrationId: number | undefined,
    utmParams: Record<string, string>,
    endpoint?: 'marketing-email-scripts',
    recommendationCropwiseData?: any,
    productCatalogData?: any
  ) => {
    const emailPayload = buildEmailPayload(
      recId,
      sipIntegrationId,
      utmParams,
      endpoint,
      recommendationCropwiseData,
      productCatalogData
    );

    try {
      const res = endpoint
        ? await ProxyLayer.sendMarketingCommercialEmail(emailPayload, endpoint)
        : await ProxyLayer.sendMarketingCommercialEmail(emailPayload);
      if (res?.data && res?.data.recommendation_solution_id) {
        console.log('Email sent successfully', res.data);
        if (sipIntegrationId) {
          console.log('Email sent with SIP integration ID:', sipIntegrationId);
        }
        trackGTMEvent('lead_form', countryCode, localCountry);

        // Update recommendation with MarketingEmailSent: true after successful marketing-email-scripts API call
        if (endpoint === 'marketing-email-scripts' && recommendationCropwiseData) {
          try {
            const updatedRecommData = JSON.parse(JSON.stringify(recommendationCropwiseData));

            // Support both multi_field and spot_check structures
            const agInputs =
              updatedRecommData?.recommendations?.[0]?.multi_field?.config?.agronomicInputs ||
              updatedRecommData?.recommendations?.[0]?.spot_check?.config?.agronomicInputs;

            if (agInputs) {
              if (!agInputs.extended_attributes) {
                agInputs.extended_attributes = {};
              }
              agInputs.extended_attributes.MarketingEmailSent = true;
            }

            await ProxyLayer.updateRecommendation({
              data: updatedRecommData,
            });
            console.log('Recommendation updated with MarketingEmailSent: true');
          } catch (updateError) {
            console.error(
              'Error updating recommendation with MarketingEmailSent flag:',
              updateError
            );
          }
        }
      }
    } catch (error) {
      console.error('Error sending marketing email:', error);
      marketingEmailSentRef.current = false; // Reset flag on error to allow retry
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isTrackingOff = urlParams.get('track') === 'off';
    const shouldSendMarketingEmail = !decodedRecParamString || shouldUseScriptEndpoint;

    // Check if extended_attributes exists and MarketingEmailSent status (only for script endpoint)
    const extendedAttributes =
      recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
        ?.extended_attributes;

    const marketingEmailAlreadySent = extendedAttributes?.MarketingEmailSent === true;

    // For script endpoint: check extended_attributes exists AND email was NOT already sent
    // For regular endpoint: no additional checks needed
    const shouldCallScriptEmail =
      shouldUseScriptEndpoint && extendedAttributes && !marketingEmailAlreadySent;
    const shouldCallRegularEmail = !shouldUseScriptEndpoint;

    const canSendEmail = shouldCallScriptEmail || shouldCallRegularEmail;

    if (!isLoading && !isTrackingOff && shouldSendMarketingEmail && canSendEmail) {
      marketingEmailSentRef.current = true; // Set flag immediately to prevent duplicate calls
      (async () => {
        try {
          let sipIntegrationId: number | undefined;

          if (isSerbia(countryName)) {
            console.log('Calling SIP integration before marketing email for Serbia');
            const sipId = await callSIPIntegration();
            if (sipId) {
              sipIntegrationId = sipId;
              console.log('SIP integration ID received:', sipIntegrationId);
            } else {
              console.warn('SIP integration returned no ID, proceeding without it');
            }
          }

          const utmParams = pushRec ? extractUtmParameters(urlParams) : {};

          if (Object.keys(utmParams).length > 0) {
            console.log(
              'Including UTM parameters in marketing email for script-generated recommendation:',
              utmParams
            );
          }

          const marketingSolutionId = recommendationCropwise?.id || recId || decodedRecParamString;

          if (!marketingSolutionId) {
            console.warn('Marketing email skipped because recommendationSolutionId is missing');
            marketingEmailSentRef.current = false;
            return;
          }

          // Get original API response without multi_field transformation
          let originalRecommendationData = recommendationCropwise;
          if (shouldUseScriptEndpoint && recommendationCropwise) {
            // Create a deep copy and remove multi_field to send original data
            const dataCopy: any = JSON.parse(JSON.stringify(recommendationCropwise));
            if (dataCopy?.recommendations?.[0]?.multi_field) {
              delete dataCopy.recommendations[0].multi_field;
            }
            originalRecommendationData = dataCopy;
          }

          await sendMarketingEmail(
            marketingSolutionId,
            sipIntegrationId,
            utmParams,
            shouldUseScriptEndpoint ? 'marketing-email-scripts' : undefined,
            shouldUseScriptEndpoint ? originalRecommendationData : undefined,
            shouldUseScriptEndpoint ? productCatalog : undefined
          );
        } catch (error) {
          console.error('Error in marketing email flow:', error);
          marketingEmailSentRef.current = false; // Reset flag on error to allow retry
        }
      })();
    }
    if (!isAnyAPILoading) {
      trackPageLoadCompletionTime();
    }
  }, [isLoading, isAnyAPILoading, recId]);

  useEffect(() => {
    if (recommendation || recommendationCropwise) {
      const language = localStorage.getItem('i18nextLng');
      const email = isDDG ? recommendation?.userContact?.email : nonDDGUserDetails.email;
      const userName = recommendation?.userContactFromAudit;
      if (window.pendo && email) {
        window.pendo.initialize({
          visitor: {
            id: email,
            email: email,
            full_name: isDDG
              ? `${userName?.firstName} ${userName?.lastName}`
              : nonDDGUserDetails.name,
            local_langauge: language,
          },
          account: {
            id: 'DDG-PENDO-ANALYSIS-ACCOUNT',
          },
        });
      }
      if (statistics && email) {
        setUserId(email);
      } else {
        setUserId(undefined);
      }
    }
  }, [recommendation, recommendationCropwise, nonDDGUserDetails, method, statistics]);

  useEffect(() => {
    const handleTabClose = () => {
      const pageLoadStartTime = pageLoadStartTimeRef.current;
      const tabCloseTime = Date.now();
      const timeSpentDuration = (tabCloseTime - pageLoadStartTime) / 1000;
      track('time spent on recommendation page', {
        'time user spends on recommendation page': timeSpentDuration,
      });
    };

    window.addEventListener('beforeunload', handleTabClose);
    return () => window.removeEventListener('beforeunload', handleTabClose);
  }, []);

  useEffect(() => {
    if (window.pendo && appLanguage) {
      const language = appLanguage || localStorage.getItem('i18nextLng');
      window.pendo.identify({
        visitor: {
          local_langauge: language,
        },
      });
    }
  }, [appLanguage]);

  useEffect(() => {
    if (
      (TrialInformationSectionVisible || FooterSectionVisible) &&
      userSpentTwoMin &&
      userSpentThirtySec &&
      !pendoManualOpen
    ) {
      feedbackBtnRef?.current?.click();
    }
  }, [
    TrialInformationSectionVisible,
    FooterSectionVisible,
    userSpentTwoMin,
    pendoManualOpen,
    userSpentThirtySec,
  ]);

  useEffect(() => {
    const generateOsrSummary = async () => {
      if (!solutionId || isDDG) {
        return;
      }

      if (process.env.REACT_APP_ENV !== 'local' && process.env.REACT_APP_ENV !== 'uat') {
        return;
      }

      if (!isOsrSummarySupportedCrop(cropName)) {
        return;
      }
      try {
        // Step 1: Check if OSR summary already exists and is completed
        let shouldGenerate = true;

        try {
          const existingSummary = await ApiDataActions.getOsrSummary(solutionId);

          //  If summary exists and is completed, skip generation
          if (existingSummary?.status === 'COMPLETED') {
            shouldGenerate = false;
          }
        } catch (error) {
          //  If summary not found (404) or any error, proceed with generation
          console.error('Error fetching existing OSR summary:', error);
          shouldGenerate = true;
        }

        // Step 2: Generate OSR summary if needed
        if (shouldGenerate && recommendationCropwise && productCatalog.length > 0) {
          const createRes = await ProxyLayer.generateOsrSummary({
            data: osrSummaryPayload,
          });

          // Step 3: If generation is pending, wait 30 seconds and fetch updated summary
          if (createRes.status === 'PENDING') {
            await pollUntilResponse(() => ApiDataActions.getOsrSummary(solutionId), {
              interval: 5000, // 5 seconds
              maxAttempts: 12, // 12 attempts = 1 minute total
              shouldContinue: (response) => response.status !== 'COMPLETED',
            });
          }
        }
      } catch (error) {
        // Step 4: Handle any errors during OSR summary generation
        console.error('Error in OSR summary flow:', error);
      }
    };

    generateOsrSummary();
  }, [solutionId, productCatalog]);

  useEffect(() => {
    if (!isLoading && recommendation) {
      rootRef?.current?.addEventListener('scroll', () => {
        if (!isPageScrolled.current && rootRef.current.scrollTop > 100) {
          isPageScrolled.current = true;
          setTimeout(() => {
            setUserSpentTwoMin(true);
          }, 2 * 60 * 1000);
        }
      });
    }
  }, [isLoading, recommendation]);

  useEffect(() => {
    if (FooterSectionVisible && !isPendoClosed) {
      setTimeout(() => {
        setUserSpentThirtySec(true);
      }, 30 * 1000);
    }
  }, [FooterSectionVisible, isPendoClosed]);

  useEffect(() => {
    document.getElementById('pendo-close-guide-b37702a5')?.addEventListener('click', () => {
      setIsPendoGuideActive(false);
      setIsPendoClosed(true);
    });
  }, [isPendoGuideActive]);

  useLayoutEffect(() => {
    const element = rootRef.current;

    function checkSrollPos() {
      if (rootRef.current.scrollTop > 100) {
        setShowBackToTopBtn(true);
      } else if (rootRef.current.scrollTop < 100) {
        setShowBackToTopBtn(false);
      }
    }
    element.addEventListener('scroll', checkSrollPos);

    return () => {
      element.removeEventListener('scroll', checkSrollPos);
    };
  }, []);

  const backToTop = () => {
    rootRef.current.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const feedbackClick = () => {
    setPendoManualOpen(true);
    setIsPendoGuideActive(true);
  };
  const handleLogoAction = () => {
    if (isDDG) {
      if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'prod') {
        window.open(routes.ddgProdUrl, '_blank');
      } else {
        const currentUrl = window.location.href;
        const ddgHomeUrl = currentUrl
          .replace('seedselector', 'seedsddg')
          .replace(/\/recommendation.*$/, '');
        window.open(ddgHomeUrl, '_blank');
      }
    }
  };

  useEffect(() => {
    if (recommendationCropwiseError || breakoutsGlobalError || breakoutsProductsSummaryError) {
      setShowModal(true);
    }
  }, [recommendationCropwiseError, breakoutsGlobalError, breakoutsProductsSummaryError]);
  const handleCalendarOpen = (changeOpenState: boolean) => {
    setCalendarOpenState(changeOpenState);
  };

  const handleSettingsClick = () => {
    setShowSectionReorderModal(true);
  };
  const handleSectionReorderSubmit = (newOrder: string[]) => {
    // Find soil characteristics position and filter it out from the regular sections
    const soilCharIndex = newOrder.indexOf('soil-characteristics');
    if (soilCharIndex !== -1) {
      setSoilCharacteristicsPosition(soilCharIndex);
      setSectionOrder(newOrder.filter((id) => id !== 'soil-characteristics'));
    } else {
      setSectionOrder(newOrder);
    }
    setShowSectionReorderModal(false);
  };
  const handleSectionReorderClose = () => {
    setShowSectionReorderModal(false);
  };

  // Create a stable SoilCharacteristics component to prevent map flickering
  const soilCharacteristicsComponent = () => (
    <>
      <SoilCharacteristics
        key="soil-characteristics-stable"
        mapCharRef={mapCharRef}
        isLoading={isLoading}
        sectionRef={soilCharRef}
        isMobile={isMobile}
        landscapeAllowed={
          sectionLandscapeAllowed &&
          currentSection === ERecommendationSections.SECTION_SOILS_CHARACTERISTICS
        }
        selectProduct={selectedProduct}
        setSelectedProductAsEmpty={() => setSelectedProduct('')}
        isDDG={isDDG}
      />
      {isMobile && isVariantD && (
        <HorizontalTabss
          selectedTab={selectedHorizontalTab}
          handleTabClick={handleHorizontalTabClick}
          isDDG={isDDG}
          countryCode={countryCode}
          crop={cropName}
          sectionOrder={sectionOrder}
        />
      )}
    </>
  );

  // Container components to avoid function declaration in loop
  const NoContainerWrapper = ({ children }: { children: React.ReactNode }) => <>{children}</>;

  // Function to render all sections including soil characteristics at the correct position
  const renderAllSections = () => {
    const allSections = [];
    const totalSections = sectionOrder.length;

    for (let i = 0; i <= totalSections; i++) {
      // Insert soil characteristics at the specified position (skip for script-generated reports)
      if (i === soilCharacteristicsPosition && !scriptGenerated) {
        allSections.push(soilCharacteristicsComponent());
      }

      // Insert the regular section if it exists
      if (i < totalSections) {
        const sectionId = sectionOrder[i];
        const sectionComponent = renderSectionInOrder(sectionId);
        if (sectionComponent) {
          // Determine container type based on section
          let ContainerComponent;
          if (
            sectionId === 'expert-seed-advice' ||
            sectionId === 'product-comparison' ||
            sectionId === 'product-performance'
          ) {
            ContainerComponent = PrimaryContainer;
          } else if (
            sectionId === 'hero-banner-0a' ||
            sectionId === 'hero-banner-0b' ||
            sectionId === 'report-overview'
          ) {
            // No container wrapper for hero banners and report overview to preserve original styling
            ContainerComponent = NoContainerWrapper;
          } else {
            ContainerComponent = SecondaryContainer;
          }

          allSections.push(
            <ContainerComponent key={sectionId}>{sectionComponent}</ContainerComponent>
          );
        }
      }
    }

    return allSections;
  };

  const renderSectionInOrder = (sectionId: string) => {
    if (isVariantD) {
      const tabToSectionMap: Record<string, string[]> = {
        RecommendedProducts: ['expert-seed-advice'],
        SeedDensityDemandAndAdvice: ['seed-density'],
        ProductComparison: ['product-comparison'],
        ProductPerformance: ['product-performance'],
        AgronomicPreferences: ['agronomic-preferences'],
        EnvironmentalStress: ['environmental-stress'],
        TrialingInformation: ['trial-information'],
        ManagementAndPlantingAdvice: ['growth-stages'],
        HerbicideTechnology: ['herbicide-technology'],
      };

      const allowedSections = tabToSectionMap[selectedHorizontalTab] || [];

      // Always show hero banners and report overview regardless of tab
      const alwaysShowSections = ['hero-banner-0a', 'hero-banner-0b', 'report-overview'];

      if (!allowedSections.includes(sectionId) && !alwaysShowSections.includes(sectionId)) {
        return null;
      }
    }

    switch (sectionId) {
      case 'hero-banner-0a':
        return isLayoutLoaded ? (
          <HeroBanner0a
            key="hero-banner-0a"
            isRecommendationAPILoading={isRecommendationAPILoading}
          />
        ) : null;
      case 'hero-banner-0b':
        return isLayoutLoaded && isMobile ? (
          <HeroBanner0b
            key="hero-banner-0b"
            isRecommendationAPILoading={isRecommendationAPILoading}
            isNonDDG={!!decodedRecParamString}
          />
        ) : null;
      case 'report-overview':
        return isLayoutLoaded && !isMobile ? (
          <>
            <ReportOverview key="report-overview" isLoading={isRecommendationAPILoading} />
            {!isMobile && isVariantD && (
              <HorizontalTabss
                selectedTab={selectedHorizontalTab}
                handleTabClick={handleHorizontalTabClick}
                isDDG={isDDG}
                countryCode={countryCode}
                crop={cropName}
                sectionOrder={sectionOrder}
              />
            )}
          </>
        ) : null;
      case 'trial-information':
        return (
          <TrialingInformation
            key="trial-information"
            isLoading={isLoadingBreakoutsAPI || isLoadingBreakoutsProductSummaryAPI}
            isHumanUser={isHumanUser}
            sectionRef={TrialInformationRef}
          />
        );
      case 'seed-density':
        return !isLoading ? (
          <SeedDensityAdvice
            key="seed-density"
            sectionRef={SeedDensityRef}
            recommendationCropwise={
              recommendationCropwise?.recommendations[0].multi_field.config || {}
            }
            recommendationAssignments={
              recommendationCropwise?.recommendations[0].multi_field.assignments || {}
            }
            propertiesFieldsInfo={propertiesFieldsInfo || []}
            productsInfo={recommendationCropwise?.recommendations[0].products || []}
            productsCatalogInfo={productCatalog || []}
            landscapeAllowed={
              sectionLandscapeAllowed &&
              currentSection === ERecommendationSections.SECTION_SEED_DENSITY_ADVICE
            }
            countryCode={
              recommendationCropwise?.country.trim() === 'Brazil'
                ? lookup.byCountry(recommendationCropwise?.country)?.iso2
                : recommendationCropwise?.country &&
                  lookup.byCountry(recommendationCropwise?.country)?.iso3
            }
            cropId={recommendationCropwise?.recommendations[0]?.crop_id}
            isNonDDG={!!decodedRecParamString}
          />
        ) : null;
      case 'growth-stages':
        return showGrowthStage() ? (
          <div ref={growthStageRef} style={growthStageStyle}>
            <GrowthStages
              key="growth-stages"
              products={growthStage}
              cropName={cropName}
              countryCode={countryCode ?? ''}
              startDate={getStartDate(recommendationCropwise, countryCode ?? '', cropName)}
              endDate={endDateForGrowthStage(
                recommendationCropwise?.recommendations[0].multi_field.config?.agronomicInputs,
                countryCode ?? '',
                cropName
              )}
              onPlantingDateChange={handlePlantingDateOnGrowthGraph}
              stressLevel={abioticStage}
              productList={recommendationCropwise?.recommendations[0].products}
              onCalenderChange={handleCalendarOpen}
            />
          </div>
        ) : null;
      case 'expert-seed-advice':
        return isSpecialEmail ? (
          <div key="expert-seed-advice">
            <ExpertSeedAdvice
              isLoading={isLoadingBreakoutsAPI || isLoadingBreakoutsProductSummaryAPI}
              sectionRef={ExpertSeedRef}
              isMobile={isMobile}
              handleOnClick={handleProductSelection}
            />
          </div>
        ) : (
          <ProductAdvice
            key="expert-seed-advice"
            isMobile={isMobile}
            isLoadingBreakoutsAPI={isLoadingBreakoutsAPI}
            isLoadingBreakoutsProductSummaryAPI={isLoadingBreakoutsProductSummaryAPI}
            isLoadingAttributesAPI={isLoadingAttributesAPI}
            ProductComparisonRef={ProductComparisonRef}
            ExpertSeedRef={ExpertSeedRef}
            ProductPerformRef={ProductPerformRef}
            handleProductSelection={handleProductSelection}
            isBrazil={isBrazilCountry}
            isRecommendationAPILoading={isRecommendationAPILoading}
            environmentalStressChartInfo={environmentalStressChartInfo}
          />
        );
      case 'product-comparison':
        return isSpecialEmail && !isLoadingAttributesAPI && !isBrazilCountry ? (
          <div key="product-comparison">
            <ProductComparison sectionRef={ProductComparisonRef} />
          </div>
        ) : null;
      case 'product-performance':
        return isSpecialEmail &&
          !isBrazilCountry &&
          environmentalStressChartInfo &&
          Object.keys(environmentalStressChartInfo).length > 0 ? (
          <div key="product-performance">
            <ProductPerformance
              sectionRef={ProductPerformRef}
              chartInfo={environmentalStressChartInfo}
            />
          </div>
        ) : null;
      case 'agronomic-preferences':
        return isSpecialEmail ? (
          <AgronomicPreferences
            key="agronomic-preferences"
            sectionRef={agPreferencesRef}
            isBrazil={countryName === CropConstants.Brazil}
          />
        ) : null;
      case 'environmental-stress':
        return isSpecialEmail &&
          !isBrazilCountry &&
          environmentalStressChartInfo &&
          Object.keys(environmentalStressChartInfo).length > 0 ? (
          <EnvironmentalStress
            key="environmental-stress"
            chartInfo={environmentalStressChartInfo}
            sectionRef={EnvStressRef}
          />
        ) : null;
      case 'herbicide-technology':
        if (
          cropName?.toLowerCase() === CropConstants.SUNFLOWER_SMALLCASE &&
          ['BG', 'HU', 'RO', 'UA'].includes((countryCode || '').toUpperCase())
        ) {
          return (
            <HerbicideTechnology
              key="herbicide-technology"
              sectionRef={herbicideTechRef}
              recommendationCropwise={recommendationCropwise}
              isDDG={isDDG}
            />
          );
        }
        return null;
      case 'diagnostics':
        return !isSpecialEmail ? (
          <div key="diagnostics" style={{ padding: '24px' }}>
            <p
              className="heading"
              style={{ margin: '0 0 24px 0', fontSize: '18px', fontWeight: 600 }}
            >
              {t('How we Arrived at Our Recommendation')}
            </p>
            <AgronomicPreferences
              sectionRef={agPreferencesRef}
              isBrazil={countryName === CropConstants.Brazil}
            />
            <HerbicideTechnology
              sectionRef={herbicideTechRef}
              recommendationCropwise={recommendationCropwise}
              isDDG={isDDG}
            />
            {!isBrazilCountry &&
              environmentalStressChartInfo &&
              Object.keys(environmentalStressChartInfo).length > 0 && (
                <EnvironmentalStress
                  chartInfo={environmentalStressChartInfo}
                  sectionRef={EnvStressRef}
                />
              )}
          </div>
        ) : null;
      default:
        return null;
    }
  };

  // VA report API call should be made in below function
  const handleVaReportSubmit = (e: any, bannerType: 'upper' | 'lower') => {
    const ddgOrSellerSS = isDDG ? 'DDG' : 'Seller SS';
    const upperOrLowerBanner =
      bannerType === 'upper'
        ? 'triggered FVA report via 1st banner on top'
        : 'triggered FVA report via 2nd banner on the bottom';

    const vaReportId = recommendationCropwise?.vareportid ?? '';

    if (showFieldVariability) {
      trackVAReportAccessed(recommendationCropwise?.email_id);
      window.open(`https://variabilityassessment.cropwise.com/report/${vaReportId}`, '_blank');
    } else if (!isDDG && vaEmailInputRef.current) {
      if (!vaEmailInputRef.current.props.value) {
        setVaReportState({
          error: true,
          reportSubmited: vaReportState.reportSubmited,
        });
      } else {
        setVaReportState({
          error: false,
          reportSubmited: true,
        });
        const email = vaEmailInputRef.current.props.value;
        const vaReportPayload: VaReportPayload = { report_id: vaReportId, email: email };
        ProxyLayer.updateGrowersEmailForVaReport(vaReportPayload);
        track(upperOrLowerBanner, {
          'e-mail address': email,
          'DDG/Seller SS': ddgOrSellerSS,
        });
      }
    } else {
      setVaReportState({
        error: false,
        reportSubmited: true,
      });
      const email = recommendationCropwise?.email_id ?? '';
      const vaReportPayload: VaReportPayload = { report_id: vaReportId, email: email };
      ProxyLayer.updateGrowersEmailForVaReport(vaReportPayload);
      track(upperOrLowerBanner, {
        'e-mail address': email,
        'DDG/Seller SS': ddgOrSellerSS,
      });
    }
  };
  return (
    <Root ref={rootRef} calendarState={calendarOpenState}>
      {currentSectionByDevice !== ESectionByDevice.desktopOrMobile && (
        <LandscapeWarningMessageContainer>
          {t('Landscape for cellphone message')}
        </LandscapeWarningMessageContainer>
      )}
      <Header
        logoAction={handleLogoAction}
        countryCode={countryCode}
        onSettingsClick={isSpecialEmail ? handleSettingsClick : undefined}
      />
      {scriptGenerated && <OSREditBanner />}
      <ContentContainer cropName={cropName ?? ''}>
        {isSpecialEmail ? (
          // Special email flow - show all sections in one view
          renderAllSections()
        ) : (
          // Regular flow with tabs
          <>
            <RecommendationInfo
              isRecommendationAPILoading={isRecommendationAPILoading}
              isNonDDG={!!decodedRecParamString}
            />
            {!scriptGenerated && (
              <SoilCharacteristics
                mapCharRef={mapCharRef}
                isLoading={isLoading}
                sectionRef={soilCharRef}
                isMobile={isMobile}
                landscapeAllowed={
                  sectionLandscapeAllowed &&
                  currentSection === ERecommendationSections.SECTION_SOILS_CHARACTERISTICS
                }
                selectProduct={selectedProduct}
                setSelectedProductAsEmpty={() => setSelectedProduct('')}
                isDDG={isDDG}
              />
            )}

            <SectionTabs
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
              isDDG={isDDG}
              countryCode={countryCode}
              isPreBookButtonVisible={isPreBookButtonVisible}
            />
            {selectedTab === RecommendationTabName ? (
              <RecommendationTab>
                {' '}
                <PrimaryContainer>
                  <ProductAdvice
                    isMobile={isMobile}
                    isLoadingBreakoutsAPI={isLoadingBreakoutsAPI}
                    isLoadingBreakoutsProductSummaryAPI={isLoadingBreakoutsProductSummaryAPI}
                    isLoadingAttributesAPI={isLoadingAttributesAPI}
                    ProductComparisonRef={ProductComparisonRef}
                    ProductPerformRef={ProductPerformRef}
                    ExpertSeedRef={ExpertSeedRef}
                    onClickToSeeDetails={() => handleTabClick(InputAndDiagnosticsTabName)}
                    handleProductSelection={handleProductSelection}
                    isBrazil={isBrazilCountry}
                    isRecommendationAPILoading={isRecommendationAPILoading}
                    environmentalStressChartInfo={environmentalStressChartInfo}
                  />
                  <TrialingInformation
                    isLoading={isLoadingBreakoutsAPI || isLoadingBreakoutsProductSummaryAPI}
                    isHumanUser={isHumanUser}
                    sectionRef={TrialInformationRef}
                  />
                </PrimaryContainer>
                <SecondaryContainer>
                  {showGrowthStage() && (
                    <div ref={growthStageRef} style={growthStageStyle}>
                      <GrowthStages
                        products={growthStage}
                        cropName={cropName}
                        countryCode={countryCode ?? ''}
                        startDate={getStartDate(
                          recommendationCropwise,
                          countryCode ?? '',
                          cropName
                        )}
                        endDate={endDateForGrowthStage(
                          recommendationCropwise?.recommendations[0].multi_field.config
                            ?.agronomicInputs,
                          countryCode ?? '',
                          cropName
                        )}
                        onPlantingDateChange={handlePlantingDateOnGrowthGraph}
                        stressLevel={abioticStage}
                        productList={recommendationCropwise?.recommendations[0].products}
                        onCalenderChange={handleCalendarOpen}
                      />
                    </div>
                  )}
                  <Divider />
                  {cropName?.toLowerCase() === CropConstants.SUNFLOWER_SMALLCASE &&
                    ['BG', 'HU', 'RO', 'UA'].includes((countryCode || '').toUpperCase()) && (
                      <>
                        <HerbicideTechnology
                          sectionRef={herbicideTechRef}
                          recommendationCropwise={recommendationCropwise}
                          isDDG={isDDG}
                        />
                      </>
                    )}
                  {!isLoading && (
                    <SeedDensityAdvice
                      sectionRef={SeedDensityRef}
                      recommendationCropwise={
                        recommendationCropwise?.recommendations[0].multi_field.config || {}
                      }
                      recommendationAssignments={
                        recommendationCropwise?.recommendations[0].multi_field.assignments || {}
                      }
                      propertiesFieldsInfo={propertiesFieldsInfo || []}
                      productsInfo={recommendationCropwise?.recommendations[0].products || []}
                      productsCatalogInfo={productCatalog || []}
                      landscapeAllowed={
                        sectionLandscapeAllowed &&
                        currentSection === ERecommendationSections.SECTION_SEED_DENSITY_ADVICE
                      }
                      countryCode={
                        recommendationCropwise?.country.trim() === 'Brazil'
                          ? lookup.byCountry(recommendationCropwise?.country)?.iso2
                          : recommendationCropwise?.country &&
                            lookup.byCountry(recommendationCropwise?.country)?.iso3
                      }
                      cropId={recommendationCropwise?.recommendations[0]?.crop_id}
                      isNonDDG={!!decodedRecParamString}
                    />
                  )}
                </SecondaryContainer>
              </RecommendationTab>
            ) : (
              <DiagnosticTab>
                <p className="heading">{t('How we Arrived at Our Recommendation')}</p>
                <AgronomicPreferences sectionRef={agPreferencesRef} isBrazil={isBrazilCountry} />
                {!isBrazilCountry &&
                  !isSouthAfrica &&
                  environmentalStressChartInfo &&
                  Object.keys(environmentalStressChartInfo).length > 0 && (
                    <EnvironmentalStress
                      sectionRef={EnvStressRef}
                      chartInfo={environmentalStressChartInfo}
                    />
                  )}
              </DiagnosticTab>
            )}
          </>
        )}
        {showVaBanner() &&
          (isMobile ? (
            <VaLowerBannerMobile
              vaEmailInputRef={vaEmailInputRef}
              error={vaReportState.error}
              reportSubmited={vaReportState.reportSubmited}
              handleVaReportSubmit={(e) => handleVaReportSubmit(e, 'lower')}
              isDDG={isDDG}
              email={VaBannerEmail}
              setEmail={setVaBannerEmail}
              showFieldVariability={showFieldVariability}
            />
          ) : (
            <VaLowerBanner
              vaEmailInputRef={vaEmailInputRef}
              error={vaReportState.error}
              reportSubmited={vaReportState.reportSubmited}
              handleVaReportSubmit={(e) => handleVaReportSubmit(e, 'lower')}
              isDDG={isDDG}
              email={VaBannerEmail}
              setEmail={setVaBannerEmail}
              showFieldVariability={showFieldVariability}
            />
          ))}
        {showPreBookSeedsBtn() &&
          !isUK(countryCode) &&
          !isFrance(countryCode) &&
          !isBelgium(countryCode) &&
          !(isGermany(countryCode) && cropId === CropConstants.BARLEY_CROP_ID) && (
            <VoucherExplanation
              isMobile={isMobile}
              countryCode={countryCode}
              isLoading={false}
              cropId={
                recommendationCropwise?.recommendations?.[0]?.crop_id ?? recommendation?.cropId
              }
              pageLoadStartTime={pageLoadStartTimeRef.current}
            />
          )}
        <Footer sectionRef={FooterRef} />
        <BackToTopBtn onClick={backToTop} visible={showBackToTopBtn}>
          <IconUpArrow color="white" />
        </BackToTopBtn>
      </ContentContainer>
      {showModal &&
        (recommendationCropwiseError || breakoutsGlobalError || breakoutsProductsSummaryError) && (
          <ConfirmationModal
            data-testid="error-modal"
            title={t(ErrorsTypeMap.MAX_ATTEMPTS.statusTitle ?? '')}
            body={t(ErrorsTypeMap.MAX_ATTEMPTS.statusMessage)}
            confirmButtonText={t('OK')}
            onClickConfirm={() => setShowModal(false)}
            showPopUpforMobile={true}
          />
        )}{' '}
      {showPopup && !isShared && !scriptGenerated && (
        <ShareRecommendationModal
          email={growerEmail || ''}
          growerName={growerName || ''}
          tsrName={tsr_name || ''}
          recommendation_url={recommendation_data}
          onClose={() => setShowPopup(false)}
          solutionId={solutionId || ''}
          recommData={recomm}
        />
      )}{' '}
      {/* Section Reorder Modal - Only visible for special email */}
      {isSpecialEmail && (
        <SectionReorderModal
          isVisible={showSectionReorderModal}
          currentOrder={[
            ...sectionOrder.slice(0, soilCharacteristicsPosition),
            'soil-characteristics',
            ...sectionOrder.slice(soilCharacteristicsPosition),
            ...(!sectionOrder.includes('herbicide-technology') ? ['herbicide-technology'] : []),
          ]}
          onSubmit={handleSectionReorderSubmit}
          onClose={handleSectionReorderClose}
        />
      )}
    </Root>
  );
}
